/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import React, { useRef, useState } from 'react';
// eslint-disable-next-line import/no-cycle
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import { handleGlobalNumericValueInputChange } from '../store/table-slice';
import { handleGlobalNumericValueInputChange as handleGlobalNumericValueInputChange2 } from '../store/table-slice2';
import PercentageInputBox from '../../../../pricing-simulator/components/table-columns/percentage-input-box';
import {
  Header,
  TableComponent,
  InputType,
} from '../../../../pricing-simulator/types/generic-table.model';
import { IMPLEMENTATION_PERIOD_2_KEY } from 'src/constants';

export default function getColumnForPercentageType(
  columnData: Header,
  columnMetadata: Header[],
  componentType: TableComponent,
  maxVal?: number,
  inputsDisabled?: boolean,
  isDisplayHeader?: boolean
) {
  const subHeader: ColumnDef<{ [key: string]: number | string }> = {
    accessorKey: columnData.parent.parent_field,
    header: props => {
      const appDispatch = useAppDispatch();
      const { pricingAction2Value} = useAppSelector((state) => state.table);
      const { kpi2ColumnMapping  } = useAppSelector((state) => state.pricingSimulator);
      const [value, setValue] = useState<number | string>();

      let isDisabled = false;
      if(!pricingAction2Value || pricingAction2Value === 0) {
        const columnId = props.column.id || '';
        if (kpi2ColumnMapping.includes(columnId)) isDisabled = true;
      }

      const handleValueChange: React.FocusEventHandler<
        HTMLInputElement
      > = e => {
        setValue(Number(e.target.value));
      };

      const handleValueChangenew: React.FocusEventHandler<
        HTMLInputElement
      > = e => {
        const inputValue = e.target.value;
        // Allow empty input, which we will handle on blur
        if (inputValue === '' || inputValue === '-') {
          setValue(inputValue);
          return;
        }
        // Allow only numeric input including negative numbers
        const numericValue = Number(inputValue);
        if (!isNaN(numericValue)) {
          setValue(inputValue);
        }
      };

      const valueRef = useRef<number>();

      const handleBlur: React.FocusEventHandler<HTMLInputElement> = e => {
        if (valueRef.current === value) {
          return;
        }
        valueRef.current = +value;
        if (TableComponent.COGS === componentType) {
          appDispatch(
            handleGlobalNumericValueInputChange2({
              columnMetadata: columnData,
              newValue: +value,
            })
          );
        } else {
          appDispatch(
            handleGlobalNumericValueInputChange({
              columnMetadata: columnData,
              newValue: +value,
            })
          );
        }
      };

      const handleBlurNew: React.FocusEventHandler<HTMLInputElement> = e => {
        if (value === '' || value === '-') {
          setValue(0);
        } else {
          if (valueRef.current === +value) {
            return;
          }
          valueRef.current = +value;
          if (TableComponent.COGS === componentType) {
            appDispatch(
              handleGlobalNumericValueInputChange2({
                columnMetadata: columnData,
                newValue: +value,
              })
            );
          } else {
            appDispatch(
              handleGlobalNumericValueInputChange({
                columnMetadata: columnData,
                newValue: +value,
              })
            );
          }
        }
      };

      return (
        <Grid container alignItems='center' flexDirection='column'>
          <Grid
            item
            xs='auto'
            container
            alignItems='center'
            className='change-text'
            onClick={props.column.getToggleSortingHandler()}
          >
            {isDisplayHeader ? (
              <Grid item sx={{ cursor: 'pointer' }}>
                {columnData.parent.alias}
                {getHeaderName(columnData)}
              </Grid>
            ) : null}
          </Grid>
          {columnData.parent.is_global_input_enable === true && (
            <Grid item xs='auto' style={{ margin: 'auto' }}>
              <input
                value={
                  componentType === TableComponent.COGS
                    ? value
                    : Math.floor(Number(value) * 100) / 100
                }
                className='table-input-box'
                type='number'
                placeholder='-'
                disabled={inputsDisabled || isDisabled}
                onChange={
                  componentType === TableComponent.COGS
                    ? handleValueChangenew
                    : handleValueChange
                }
                onBlur={
                  componentType === TableComponent.COGS
                    ? handleBlurNew
                    : handleBlur
                }
              />
            </Grid>
          )}
        </Grid>
      );
    },
    cell: ({ cell, row }) => {
      const idColumns: Header[] = columnMetadata
        .filter(
          data =>
            !data.parent.is_visible &&
            data.parent.field_format === InputType.NUMBER
        )
        .sort((a, b) => a.parent.level - b.parent.level);
      const { summary: summaryAccessConfig } = useAppSelector(
        state => state.simulatorHome.moduleAccessMap
      );
      const { kpi2ColumnMapping } = useAppSelector(
        state => state.pricingSimulator
      );

      let disabled = false;
      const implementPeriod2Value =
        row.original?.[IMPLEMENTATION_PERIOD_2_KEY] || 0;
      if (implementPeriod2Value === 0) {
        const cellId = cell?.column?.id || '';
        if (kpi2ColumnMapping.includes(cellId)) disabled = true;
      }

      if (TableComponent.MULTIYEARESTIMATE === componentType) {
        const isParent = !row.getParentRow();
        if (isParent) {
          return <span>-</span>;
        }
        if (row.index === 0) {
          return <span>-</span>;
        }
      }
      return (
        <PercentageInputBox
          row={row}
          uniqueIDColumns={idColumns}
          columnMetadata={columnData}
          componentType={componentType}
          inputsDisabled={
            inputsDisabled ||
            (TableComponent.MULTIYEARESTIMATE === componentType &&
              !summaryAccessConfig?.provide_inputs_multi_year_estimate) ||
            disabled
          }
        />
      );
    },
    meta: {
      className:
        columnData.parent.order === maxVal || maxVal === undefined
          ? 'last'
          : '',
      style: { minWidth: '125px', textAlign: 'center' },
    },
  };
  return subHeader;
}
